import { INetworkResult } from '@/coreDomainsModule/networkResult';
import {
  BulkPostSupplierForecastRequest,
  BulkSupplierForecastResponseInfo,
} from '@/coreInfrastructureModule/axios/generated/supplierForecastManage';
import { putSupplierForecastAdapter } from '../adapters/putSupplierForecastAdapter';
import { IYearMonth } from '@/coreDomainsModule/date';
import { ISupplierForecastRepository } from '@/coreInfrastructureModule/interfaces/ISupplierForecastRepository';
import { IAnnounce } from '@/coreDomainsModule/entities/forecast';

/**
 * 仕入先内示保存のビジネスロジック
 */
export class PutSupplierForecastUseCase {
  private repository: ISupplierForecastRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: ISupplierForecastRepository) {
    this.repository = repository;
  }

  /**
   * 仕入先内示に使用するUseCase
   * DBの定義とIBusinessとの形式の差異をここで合わせて登録する
   * @param registerSupplierForecastInfo - 集計されていないビジネス
   * @param equalCustomerForecast - 客先内示と同じかどうかを示すフラグ
   * @param createdYearMonth - 仕入先内示作成月
   * @param registerSupplierForecastRange - 登録する仕入先内示の期間
   * @param aggregateBusinessId - 集計ID
   * @param userUpsert - upsert処理を実行するかのフラグ
   */
  async Execute(
    registerSupplierForecastInfo: IAnnounce[],
    equalCustomerForecast: boolean,
    createdYearMonth: IYearMonth,
    registerSupplierForecastRange: number,
    aggregateBusinessId: string,
    userUpsert = false
  ): Promise<INetworkResult<BulkSupplierForecastResponseInfo, Error>> {
    // アダプター
    const requestInfo = putSupplierForecastAdapter.adapt(
      registerSupplierForecastInfo,
      equalCustomerForecast,
      createdYearMonth,
      registerSupplierForecastRange,
      aggregateBusinessId
    );

    // requestで送る情報
    const requestBody: BulkPostSupplierForecastRequest = {
      useUpsert: userUpsert,
      bulkPostSupplierForecastInfo: requestInfo,
    };
    try {
      const result = await this.repository.bulkPut(requestBody);
      switch (result.status.type) {
        case 'success':
          break;
        case 'error':
          throw result.status.error;
        default:
          throw Error('想定外のエラー');
      }

      return {
        status: {
          type: 'success',
          data: result.status.data,
        },
      };
    } catch (error) {
      console.error('error', error); // 基本的にはここには来ない
      return {
        status: {
          type: 'error',
          error: error as Error,
        },
      };
    }
  }
}
